/**
 * User information returned from the auth server.
 */
export interface UserInfo {
  name?: string;
  email?: string;
  family_name?: string;
  given_name?: string;
  preferred_username?: string;
  // the id of the user from the authenticator (fusionauth)
  sub?: string;
}

export const isViamUser = (user: UserInfo | undefined) =>
  Boolean(user?.email?.endsWith('@viam.com'));
